import { useQueryClient, useMutation } from "react-query";
import { updateRoleManagement } from "../../../../../actions/Utilities/ModuleManagement";
import { toast } from "../../../../../components/toastNotification";

export const useUpdateRoleData = (onSuccessCallback?: () => void) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userPermissions) => updateRoleManagement(userPermissions),

    onSuccess: (res) => {
      if (!res) return;

      if (res.statusCode === 500 || res.statusCode === 400) {
        toast.fire("Server Error", "Cannot display data", "error");
      }

      if (res === "Duplicate") {
        toast.fire("Failed", "Role already exist", "warning");
      }

      if (res.statusCode === 200 || res.statusCode === 201) {
        toast.fire("Success", "Role has been updated successfully.", "success");
      }

      queryClient.invalidateQueries({ queryKey: ["AllUser"] });
      queryClient.invalidateQueries({ queryKey: ["GetRolesWithUsers"] });

      onSuccessCallback?.();
    },
  });
};
